import type { FC } from "react";
import React from "react";
import type { MytripsLoginModalContainerProps } from "@components/AuthFlow/AuthenticationModal/contract";
import { ForgotPassword } from "@components/AuthFlow/ForgotPassword";
import { SuccessScreen } from "@components/AuthFlow/Success";
import { useModalState } from "clientState/AuthFlow/providers/ModalScreenProvider";
import {
  screenNames,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { SystemModal } from "@edreamsodigeo/prisma-design-system";

const { FORGOT_PASSWORD, SUCCESS, NONE } = screenNames;
const MytripsLoginModalContainer: FC<MytripsLoginModalContainerProps> = ({
  closeModal,
}) => {
  const { state } = useScreenState();
  const { screen } = state;
  const { selectedFlow } = useModalState();

  const isOpen =
    selectedFlow !== NONE && (screen === FORGOT_PASSWORD || screen === SUCCESS);

  return (
    <SystemModal open={isOpen}>
      {screen === FORGOT_PASSWORD && (
        <ForgotPassword
          isInitial={true}
          closeScreen={closeModal}
          trackingPrefix={state.trackingPrefix}
        />
      )}
      {screen === SUCCESS && (
        <SuccessScreen trackingPrefix={state.trackingPrefix} />
      )}
    </SystemModal>
  );
};

export default MytripsLoginModalContainer;
